<template>
  <div class="flex flex-col items-center text-center">
    <KIcon
      v-if="icon"
      :name="icon"
      class="
        mb-4
        md:mb-12
        w-10
        md:w-20
        h-8
        md:h-16
        fill-current
        text-primary
      "
    />
    <template v-if="image">
      <div
        v-if="image.isIcon"
        v-dompurify-html:svg="dynamicIconSource"
        class="selection-card-layout__dynamic-icon"
      />
      <img
        v-else
        :alt="image.alt"
        :src="image.source"
        class="selection-card-layout__image"
      />
    </template>
    <div
      v-if="title"
      class="text-base md:text-xl font-bold"
      :class="{ 'mb-6': !!body }"
    >
      {{ title }}
    </div>
    <div
      v-if="body"
      class="text-xs md:text-sm text-black-high-emphasis"
      v-dompurify-html="body"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { IconName, iconNames } from '@/components/atoms/Icon/icons'
import KIcon from '@/components/atoms/Icon/index.vue';
import KImage from '@/types/KImage'
import useRemoteIcon from '@/hooks/useRemoteIcon'

export default defineComponent({
  name: 'SelectionCardLayout',
  components: { KIcon },
  props: {
    image: {
      type: Object as () => KImage,
      required: false
    },
    icon: {
      type: String as () => IconName,
      required: false,
      validator: (value: string | undefined) =>
        value ? iconNames.includes(value) : true
    },
    title: {
      type: String,
      required: false
    },
    body: {
      type: String,
      required: false
    }
  },
  setup (props) {
    const dynamicIconSource = props.image?.isIcon && props.image.source
      ? useRemoteIcon(props.image.source)
      : null

    return { dynamicIconSource }
  }
})
</script>

<style>
.selection-card-layout {
  &__dynamic-icon {
    svg {
      @apply mb-4 w-10 h-8 fill-current text-primary;
    }
  }

  &__image {
    @apply max-w-full mb-8 -mx-6;
    max-height: 78px;
  }
}

@screen md {
  .selection-card-layout {
    &__dynamic-icon {
      svg {
        @apply mb-12 w-20 h-16
      }
    }

    &__image {
      @apply mb-12;
      max-height: 146px;
    }
  }
}
</style>
